import React from 'react';

// Utils
import { dateFormat } from '~/utils/date-format';
import { getFindNewContactsSearchMethod } from '../../utils/find-new-contacts';

// MUI Components
import { Box, Typography, Skeleton } from '@mui/material';

// Styles
import './styles.scss';

const getSourceDisplay = (data, overview) => {
  const baseSource = data?.source;
  if (!baseSource) return '-';

  const contactImportLog = overview?.contactImportLog;
  const isFindNewContactsPurchase = Boolean(
    data?.isFindNewContactsPurchaseOnly ||
      overview?.isFindNewContactsPurchaseOnly ||
      data?.meta?.findNewContactsPurchase ||
      data?.meta?.source === 'find_new_contacts_data_axle'
  );

  // Case 1: list upload — contactImportLog object is present
  if (contactImportLog) {
    const listName = contactImportLog.fileName || data?.importListName || '';
    if (contactImportLog.meta?.source === 'find_new_contacts_data_axle') {
      const quantity = contactImportLog.meta?.purchase?.quantity || contactImportLog.quantity;
      const quantityLabel = quantity ? ` (${Number(quantity).toLocaleString('en-US')} records)` : '';
      const searchMethod = getFindNewContactsSearchMethod(data, overview);
      return listName
        ? `${baseSource} - ${searchMethod} - ${listName}${quantityLabel}`
        : `${baseSource} - ${searchMethod}${quantityLabel}`;
    }

    return listName
      ? `${baseSource} - List Upload - ${listName}`
      : `${baseSource} - List Upload`;
  }

  if (isFindNewContactsPurchase) {
    const quantity = data?.meta?.purchase?.quantity || data?.meta?.targetCount || data?.quantity;
    const quantityLabel = quantity ? ` (${Number(quantity).toLocaleString('en-US')} records)` : '';
    const listName = data?.meta?.listName || data?.meta?.purchase?.listName || data?.importListName || data?.name || '';
    const searchMethod = getFindNewContactsSearchMethod(data, overview);

    return listName
      ? `${baseSource} - ${searchMethod} - ${listName}${quantityLabel}`
      : `${baseSource} - ${searchMethod}${quantityLabel}`;
  }

  // Case 3: tag-based order — no import log but importListName is set
  if (data?.importListName) {
    return `${baseSource} - Tags - ${data.importListName}`
  }

  // Case 2: created from contacts — no import log, no importListName
  return baseSource;
};

const OrderStats = ({ 
  data,
  overview,
  loading 
}) => {
  const isFindNewContactsPurchase = Boolean(
    data?.isFindNewContactsPurchaseOnly ||
      overview?.isFindNewContactsPurchaseOnly ||
      overview?.contactImportLog?.meta?.source === 'find_new_contacts_data_axle' ||
      data?.contactImportLogs?.[0]?.meta?.source === 'find_new_contacts_data_axle' ||
      data?.meta?.findNewContactsPurchase ||
      data?.meta?.source === 'find_new_contacts_data_axle'
  );
  const stats = [
    { label: 'Source', value: getSourceDisplay(data, overview) },
    { label: 'Payment Status', value: data?.paymentStatus || '-' },
    { label: 'Created By', value: data?.creator?.fullName || '-' },
    {
      label: 'Product Type',
      value: isFindNewContactsPurchase ? 'Find New Contacts' : data?.product?.productType || '-',
    },
    { label: 'Created Date', value: overview?.orderDates?.createdDateDisplay || (data?.createdAt ? dateFormat(data?.createdAt, true) : '-') }
  ];

  if (loading) {
    return (
      <Box className="orderStatsContainer">
        <Typography variant="h6" className="orderStatsTitle">
          Order Details
        </Typography>
        <Box className="orderStatsGrid">
          {Array.from({ length: 5 }).map((_, index) => (
            <Box key={index} className="orderStatItem">
              <Skeleton variant="text" width="60%" height={16} />
              <Skeleton variant="text" width="80%" height={20} />
            </Box>
          ))}
        </Box>
      </Box>
    );
  }

  return (
    <Box className="orderStatsContainer">
      <Typography variant="h6" className="orderStatsTitle">
        Order Details
      </Typography>
      <Box className="orderStatsGrid">
        {stats.map((stat, index) => (
          <Box key={index} className="orderStatItem">
            <Typography className="orderStatLabel">
              {stat.label}
            </Typography>
            <Typography 
              className={`orderStatValue`}
            >
              {stat.value}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default OrderStats;
